<template>
  <base-text-field v-bind="{ ...$attrs, ...$props }" v-on="$listeners" :rules="allRules" />
</template>

<script>
export default {
  props: {
    rules: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    allRules() {
      return [...this.rules, (value) => (!!value && !!value.match(/.+@.+\..+/)) || "Must be a valid email"];
    },
  },
};
</script>
